module.exports = __webpack_public_path__ + "static/apple_store_badge-9aecb08e277fbf74b0392306bdce1405.svg";